import axios from 'axios'

const defaultState = () => {
  return {
    seller: {},
    token: localStorage.getItem('sellerToken'),
    blockList: []
  }
}

const state = defaultState()

const getters = {
  isLogin: state => !!state.token,
}

const mutations = {
  login(state, token) {
    state.token = token
    localStorage.setItem('sellerToken', token)
  },
  logout(state) {
    localStorage.setItem('sellerToken', '')
    Object.assign(state, defaultState())
  },
  setSeller(state, seller) {
    state.seller = seller
  },
  setToken(state, token) {
    state.token = token
    localStorage.setItem('sellerToken', token)
  },
  setNickname(state, name) {
    state.seller.nickname = name
  },
  setBlockList(state, blockList) {
    state.blockList = blockList
  }
}

const actions = {
  login({ commit }, token) {
    commit('login', token)
  },
  logout({ commit }) {
    commit('logout')
  },
  setSeller({ commit }, seller) {
    commit('setSeller', seller)
  },
  setToken({ commit, state }, token) {
    commit('setToken', token)
  },
  getSellerInformation({ commit, state }, target=null) {
    return new Promise(function(resolve, reject) {
      if(state.token) {
        axios('/portal/me').then(response => {
          response.data.wallpaper = response.data.wallpaper ? response.data.wallpaper + `?t=${Date.now()}` : ''
          response.data.usericon = response.data.usericon ? response.data.usericon + `?t=${Date.now()}` : ''
          commit('setSeller', response.data)
          resolve()
        })
      }
      else {
        reject()
      }
    })
  },
  setNickname({ commit }, name) {
    commit('setNickname', name)
  },
  getBlockList({ commit }) {
    return axios('/portal/block').then(response => {
      commit('setBlockList', response.data)
    })
  },
  block({ commit }, member_id, callback) {
    return axios.post('/portal/block', {
      member_id: member_id
    }).then(response => {
      this.dispatch('seller/getBlockList')
      callback ? callback() : null
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}